import {KeyboardSymbolKind, KeyboardCommands, commands as defaultCommands} from 'ui/keyboard';

export function handleKeyPress(
  state: KeyboardState,
  key: KeyboardSymbol,
  actions: KeyboardCommands = defaultCommands
): KeyboardState {
  switch (key.type) {
    case KeyboardSymbolKind.Number:
    case KeyboardSymbolKind.Comma:
      return actions.addSymbol(state, key.value.toString());

    case KeyboardSymbolKind.Backspace:
      return actions.removeLastSymbol(state);

    case KeyboardSymbolKind.Clear:
      return actions.clear();

    default:
      return state;
  }
}
